import type { OnInit } from '@angular/core';
import { Directive, ElementRef, inject, Input, Renderer2 } from '@angular/core';
import type { ImageResult } from '../../types';
import { decode } from 'blurhash';

@Directive({
    selector: '[spBlurhashImage]',
    standalone: true,
})
export class BlurHashDirective implements OnInit {
    @Input('spBlurhashImage') image!: ImageResult;
    @Input() size: keyof ImageResult['urls'] = 'thumb';

    private readonly el: ElementRef<HTMLImageElement> = inject(ElementRef);
    private readonly renderer: Renderer2 = inject(Renderer2);

    ngOnInit() {
        if (!this.image) return;

        const canvas = this.getImageFromBlurHash(this.image).toDataURL();
        this.renderer.setAttribute(this.el.nativeElement, 'src', canvas);

        const img = new Image();
        img.src = this.image.urls[this.size];

        img.onload = () => {
            this.renderer.setAttribute(this.el.nativeElement, 'src', img.src);
        };
    }

    private getImageFromBlurHash(image: ImageResult): HTMLCanvasElement {
        const canvas = document.createElement('canvas');

        const width = image.width || 240;
        const r = width / 240;
        canvas.width = width / r;
        canvas.height = (image.height || 180) / r;

        try {
            if (image.blurHash) {
                const pixels = decode(image.blurHash, canvas.width, canvas.height);
                const ctx = canvas.getContext('2d');
                const imageData = ctx!.createImageData(canvas.width, canvas.height);
                imageData.data.set(pixels);
                ctx!.putImageData(imageData, 0, 0);
            }
        } catch {
            console.error('Error decoding blurhash for image', image.id);
        }
        return canvas;
    }
}
